import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import '../../../styles/index.scss';
import { Footer, Header } from '..';

import styles from './PerpetualMassesLayout.module.scss';

const PerpetualMassesLayout = React.memo(({ children }) => {
  return (
    <>
      <div className={classNames('app h-100 d-flex flex-column', styles.self)}>
        <Header
          description="Zamów Msze Święte wieczyste"
          customColors={{
            primary: '#fcb900',
            secondary: '#323433',
          }}
        />

        <main className="container-lg flex-grow-1 flex-shrink-0 d-flex flex-column mt-5">
          <h1 className="el-h4 mb-4">Msze Święte wieczyste</h1>

          {children}
        </main>

        <div className={styles.footerWrapper}>
          <Footer isWhite />
        </div>
      </div>
    </>
  );
});

PerpetualMassesLayout.propTypes = {
  children: PropTypes.node,
};

export default PerpetualMassesLayout;
